import { useRef } from 'react'

import style from './_inbox-container.module.scss'
import { InboxContext } from './InboxContext'
import { type IInboxContext } from './types'

const InboxContainer = ({
    children,
    customClass = '',
    containerRef
}: {
    children: JSX.Element | JSX.Element[]
    customClass?: string
    scrollToBottom?: boolean
    containerRef?: any
}) => {
    const inboxRef = useRef()

    const changeClass = (className: string, type: 'add' | 'remove') => {
        const element = containerRef?.current
            ? containerRef?.current
            : inboxRef.current
            ? inboxRef.current
            : null

        if (element) {
            if (type === 'add') {
                element.classList.add(className)
            } else if (type === 'remove') {
                element.classList.remove(className)
            }
        }
    }

    const contextObject: IInboxContext = {
        changeClass
    }

    return (
        <InboxContext.Provider value={contextObject}>
            <div
                ref={containerRef || inboxRef}
                className={`${style.container} ${customClass}`}
            >
                {children}
            </div>
        </InboxContext.Provider>
    )
}

export default InboxContainer
